export type CurrencyCode = 'GEL' | 'USD' | 'EUR';

export interface Money {
  readonly amount: number;
  readonly currency: CurrencyCode;
}

export function money(amount: number, currency: CurrencyCode): Money {
  if (!Number.isFinite(amount)) {
    throw new Error(`Invalid Money amount: ${amount}`);
  }
  return Object.freeze({ amount, currency });
}

export function addMoney(a: Money, b: Money): Money {
  if (a.currency !== b.currency) {
    throw new Error(`Cannot add Money of different currencies: ${a.currency} vs ${b.currency}`);
  }
  return money(a.amount + b.amount, a.currency);
}
